import React from "react";
import banaoLogoPng from "../../Images/Banao_Logo.png";

// The company's logo (S3b: nothing about one company is baked in). Shows the logo the
// company set (me.company.logoUrl) and falls back to the built-in Banao Technologies
// mark, which replaced the old ATG globe on 2026-10-13 (owner's instruction).
export const DEFAULT_LOGO = banaoLogoPng;

const CompanyLogo = ({ company, size = 32 }) => (
  <img
    className="Company-Logo"
    src={(company && company.logoUrl) || DEFAULT_LOGO}
    alt={`${(company && company.displayName) || "Banao Technologies"} logo`}
    width={size}
    height={size}
  />
);

// Kept so older imports keep working; the same component.
export const ATGLogo = CompanyLogo;
